// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"16beeca5","400":"a7d8002c","453":"105f89ca","455":"e204f3be"}[chunkId] + ".chunk.js";
};